let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3ysp0")).then(() => parcelRequire('1VAz6'));